module.exports = __webpack_public_path__ + "static/media/personal_photo.e38a4c9a.webp";